function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import { withGenericConfig } from "contexts/generic-config-context";
import classnames from "classnames";
import colors from "styles/colors";
import { HEADER_SUBMENU_LINK_CLICKED } from "/constants/bigbrain-event-types";
import { trackEvent } from "/services/bigbrain-service";
import TitleLine from "static/svg/header/header_subtitle_line.svg";
import MondayMarkupLanguageComponent from "client/components/system/monday-markup-language/monday-markup-language-component";
import { BACKGROUND_GRAY_COLOR_NAME, WHITE_COLOR_NAME } from "styles/color-consts";
import PictureComponent from "components/core/picture/picture-component";
import Button from "segments/desktop/core-components/button/button";
import { SECONDARY_BUTTON_TYPE } from "segments/desktop/core-components/button/button-consts";
import { StyledHeaderMenuSectionComponent } from "./header-menu-section-component.scss";
import HeaderMenuSectionItemComponent from "../header-menu-section-item/header-menu-section-item-component";
import { fireGtmEvent } from "client/services/gtm-service/gtm-service";
import DataLayerEventTypes from "constants/data-layer-event-types";
import { MENU_ID_TO_EVENT_KIND_MAP } from "segments/desktop/header/layouts/base-header/base-header-desktop/consts";
import Tags from "segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/sections-header-menu/header-menu-section/components/tags";
const MAX_NUMBER_OF_ITEMS_IN_COLUMN_DEFAULT = 3;
const HeaderMenuSectionComponent = (props)=>{
    const { menuSectionItems, maxNumberOfItemsInColumn, title, subtitle, seeMoreItem, translate, classname, titleLine, titleImage, titleCTA, tags, titleUrl, menuId, id, withTitleUnderline } = props;
    const onButtonClicked = useCallback((event, url, eventInfo)=>{
        fireGtmEvent(DataLayerEventTypes.CLICK_MAIN_NAV, {
            click_text: translate(titleCTA === null || titleCTA === void 0 ? void 0 : titleCTA.title),
            parent_category: MENU_ID_TO_EVENT_KIND_MAP[menuId]
        });
        trackEvent(HEADER_SUBMENU_LINK_CLICKED, {
            kind: url,
            info1: eventInfo,
            info2: menuId,
            info3: id
        });
        event === null || event === void 0 ? void 0 : event.stopPropagation();
    }, [
        id,
        menuId,
        titleCTA === null || titleCTA === void 0 ? void 0 : titleCTA.title,
        translate
    ]);
    const getStyle = (menuSectionItem)=>{
        const { backgroundColor, hoverBackgroundColor } = menuSectionItem;
        const backgroundColorValue = backgroundColor || colors[WHITE_COLOR_NAME];
        const hoverBackgroundColorValue = hoverBackgroundColor || colors[BACKGROUND_GRAY_COLOR_NAME];
        return {
            "--header-menu-section-item-background-color": backgroundColorValue,
            "--header-menu-section-item-hover-background-color": hoverBackgroundColorValue
        };
    };
    const renderHeaderMenuItems = useCallback(()=>{
        return menuSectionItems.map((menuSectionItem)=>{
            return /*#__PURE__*/ _jsx(HeaderMenuSectionItemComponent, _object_spread_props(_object_spread({}, menuSectionItem), {
                menuId: menuId,
                sectionId: id
            }));
        });
    }, [
        menuSectionItems
    ]);
    const renderBtnFromConfig = useCallback((btnConfig)=>{
        if (!btnConfig) return null;
        const { title: btnText, buttonType = SECONDARY_BUTTON_TYPE, eventInfo } = btnConfig, config = _object_without_properties(btnConfig, [
            "title",
            "buttonType",
            "eventInfo"
        ]);
        const buttonConfig = _object_spread({
            buttonText: translate(btnText),
            buttonType,
            onClick: (event)=>onButtonClicked(event, config === null || config === void 0 ? void 0 : config.url, eventInfo)
        }, config);
        return /*#__PURE__*/ _jsx(Button, _object_spread({}, buttonConfig));
    }, [
        onButtonClicked,
        translate
    ]);
    const onTitleClick = (e)=>{
        const isKeyboardEvent = (e === null || e === void 0 ? void 0 : e.screenX) === 0 && (e === null || e === void 0 ? void 0 : e.screenY) === 0;
        if (titleUrl) {
            fireGtmEvent(DataLayerEventTypes.CLICK_MAIN_NAV, {
                click_text: id,
                parent_category: MENU_ID_TO_EVENT_KIND_MAP[menuId]
            });
            trackEvent(HEADER_SUBMENU_LINK_CLICKED, {
                kind: titleUrl,
                info1: isKeyboardEvent ? "keyboard" : "mouse",
                info2: menuId,
                info3: id
            });
            window.location.href = titleUrl;
        }
    };
    return /*#__PURE__*/ _jsxs(StyledHeaderMenuSectionComponent, {
        className: "header-menu-section-component",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: classnames("header-menu-section-title", {
                    "with-underline": withTitleUnderline,
                    "with-image-and-CTA": titleImage && titleCTA
                }),
                onClick: onTitleClick,
                children: [
                    (titleImage || titleCTA) && /*#__PURE__*/ _jsxs("div", {
                        className: "header-menu-section-title-image-and-cta",
                        children: [
                            titleImage && /*#__PURE__*/ _jsx("a", {
                                href: titleUrl,
                                tabIndex: "-1",
                                children: /*#__PURE__*/ _jsx(PictureComponent, {
                                    src: titleImage,
                                    className: "header-menu-section-title-image"
                                })
                            }),
                            renderBtnFromConfig(titleCTA)
                        ]
                    }),
                    tags && /*#__PURE__*/ _jsx(Tags, {
                        tags: tags,
                        translate: translate
                    }),
                    titleLine && /*#__PURE__*/ _jsx(TitleLine, {
                        className: "header-menu-section-title-line"
                    }),
                    /*#__PURE__*/ _jsx(MondayMarkupLanguageComponent, {
                        className: "header-menu-section-title-text",
                        text: translate(title)
                    })
                ]
            }),
            subtitle && /*#__PURE__*/ _jsx("div", {
                className: "header-menu-section-subtitle",
                children: /*#__PURE__*/ _jsx(MondayMarkupLanguageComponent, {
                    text: translate(subtitle)
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: classnames("header-menu-section-items-wrapper", classname),
                style: {
                    "--max-number-of-items-in-column": maxNumberOfItemsInColumn
                },
                children: renderHeaderMenuItems()
            }),
            seeMoreItem && /*#__PURE__*/ _jsx("div", {
                className: "header-menu-see-more-wrapper",
                children: renderBtnFromConfig(seeMoreItem)
            })
        ]
    });
};
export default withGenericConfig(HeaderMenuSectionComponent);
HeaderMenuSectionComponent.defaultProps = {
    maxNumberOfItemsInColumn: MAX_NUMBER_OF_ITEMS_IN_COLUMN_DEFAULT
};
